import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { postGoalV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(postGoalV2),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: GoalsKeys.all });
		},
	});
};
